<template>
  <v-container class="content-detail">
    <v-form ref="form" class="compare-form">
      <v-row
        class="d-flex flex-column-reverse flex-lg-row mx-0 align-center align-lg-start"
      >
        <v-col cols="12" sm="10" lg="8" class="pa-md-8 pa-lg-8 mb-10 mb-lg-0">
          <v-row class="align-center mb-3 mb-md-10">
            <v-col>
              <div class="d-flex justify-end action-group">
                <v-btn
                  :color="treeData.isAdvance ? '#FFF777' : 'rgb(255 252 204)'"
                  title="簡易樹木種類"
                  class="ct-text-bolder d-flex justify-center align-center mr-4"
                  :class="{ 'shadow-btn': !treeData.isAdvance }"
                  @click="treeData.isAdvance = false"
                >
                  <span style="display:inline-block">簡易樹木種類</span>
                </v-btn>
                <v-btn
                  :color="!treeData.isAdvance ? '#FFF777' : 'rgb(255 252 204)'"
                  title="進階樹木種類"
                  class="ct-text-bolder d-flex justify-center align-center"
                  :class="{ 'shadow-btn': treeData.isAdvance }"
                  @click="treeData.isAdvance = true"
                >
                  <span style="display:inline-block">進階樹木種類</span>
                </v-btn>

                <div
                  class="ct-text-bolder ml-12 formula-wrap d-flex align-center"
                >
                  <v-btn
                    :color="'rgb(85,117,82)'"
                    text
                    title="公式說明"
                    @click="formulaDialog = true"
                  >
                    <v-icon>mdi-help-circle</v-icon>
                    <span style="display:inline-block">公式說明</span>
                  </v-btn>
                  <span class="required-note">
                    *複測值為選填
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="align-center mb-3 mb-md-10 field-row">
            <v-col cols="auto" class="px-1 field-label-col">
              <label
                for="treeType"
                class="calculator-title font-weight-bold color-tree d-block"
              >
                樹木種類
              </label>
            </v-col>
            <v-col class="px-1 field-input-col">
              <v-autocomplete
                id="treeType"
                ref="treeType"
                v-model="treeData.type"
                item-text="Name"
                item-value="Sno"
                dense
                placeholder="請選擇樹木種類"
                outlined
                solo
                hide-details
                :rules="SYS.Required()"
                :items="treeData.isAdvance ? treeCo2List : entryCo2List"
                @click="changeTreeImage('type')"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="align-start mb-2 field-row">
            <v-col
              cols="auto"
              class="px-1 field-label-col compare-title-spacer"
            ></v-col>
            <v-col class="px-1 text-center field-input-col">
              <span class="compare-title">基準值</span>
            </v-col>
            <v-col class="px-1 text-center field-input-col">
              <span class="compare-title">複測值</span>
            </v-col>
          </v-row>

          <v-row class="align-start mb-3 mb-md-3 field-row">
            <v-col cols="auto" class="px-1 field-label-col">
              <label
                for="baseTreeHeight"
                class="calculator-title font-weight-bold color-tree d-block"
              >
                樹高 (公尺)
              </label>
            </v-col>
            <v-col class="px-1 field-input-col">
              <v-text-field
                id="baseTreeHeight"
                ref="baseHeight"
                v-model="treeData.base.height"
                label="請輸入樹高 (公尺)"
                solo
                :hide-details="false"
                :rules="[requiredNumberRule('樹高 (公尺)')]"
                @click="changeTreeImage('height')"
              ></v-text-field>
            </v-col>
            <v-col class="px-1 field-input-col">
              <v-text-field
                id="recheckTreeHeight"
                ref="recheckHeight"
                v-model="treeData.recheck.height"
                label="請輸入樹高 (公尺)"
                solo
                :hide-details="false"
                :rules="[optionalNumberRule('樹高 (公尺)')]"
                @click="changeTreeImage('height')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="align-start mb-7 field-row measurement-actions">
            <v-col cols="auto" class="px-1 field-label-col">
              <v-btn color="#FFF777" @click="measurementDialog = true"
                >直徑測量說明</v-btn
              >
            </v-col>
            <v-col class="px-1 text-center field-input-col">
              <v-btn
                color="#FFF777"
                aria-label="基準值樹幹分枝轉換"
                @click="openBranchDialog('base')"
                >樹幹分枝轉換</v-btn
              >
            </v-col>
            <v-col class="px-1 text-center field-input-col">
              <v-btn
                color="#FFF777"
                aria-label="複測值樹幹分枝轉換"
                @click="openBranchDialog('recheck')"
                >樹幹分枝轉換</v-btn
              >
            </v-col>
          </v-row>

          <v-row class="align-start mb-3 mb-md-10 field-row">
            <v-col cols="auto" class="px-1 field-label-col">
              <label
                for="baseTreeDiameter"
                class="calculator-title font-weight-bold color-tree d-block"
              >
                胸高直徑 (公分)
              </label>
            </v-col>
            <v-col class="px-1 field-input-col">
              <v-text-field
                id="baseTreeDiameter"
                ref="baseDiameter"
                v-model="treeData.base.diameter"
                label="請輸入胸高直徑 (公分)"
                solo
                :hide-details="false"
                :rules="[requiredNumberRule('胸高直徑 (公分)')]"
                @click="changeTreeImage('diameter')"
                @input="calculatePerimeter('base', treeData.base.diameter)"
              ></v-text-field>
            </v-col>
            <v-col class="px-1 field-input-col">
              <v-text-field
                id="recheckTreeDiameter"
                ref="recheckDiameter"
                v-model="treeData.recheck.diameter"
                label="請輸入胸高直徑 (公分)"
                solo
                :hide-details="false"
                :rules="[optionalNumberRule('胸高直徑 (公分)')]"
                @click="changeTreeImage('diameter')"
                @input="
                  calculatePerimeter('recheck', treeData.recheck.diameter)
                "
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="align-start mb-3 mb-md-10 field-row">
            <v-col cols="auto" class="px-1 field-label-col">
              <label
                for="baseTreePerimeter"
                class="calculator-title font-weight-bold color-tree d-block"
              >
                胸高周長 (公分)
              </label>
            </v-col>
            <v-col class="px-1 field-input-col">
              <v-text-field
                id="baseTreePerimeter"
                ref="basePerimeter"
                v-model="treeData.base.perimeter"
                label="請輸入胸高周長 (公分)"
                solo
                :hide-details="false"
                :rules="[requiredNumberRule('胸高周長 (公分)')]"
                @click="changeTreeImage('perimeter')"
                @input="calculateDiameter('base', treeData.base.perimeter)"
              ></v-text-field>
            </v-col>
            <v-col class="px-1 field-input-col">
              <v-text-field
                id="recheckTreePerimeter"
                ref="recheckPerimeter"
                v-model="treeData.recheck.perimeter"
                label="請輸入胸高周長 (公分)"
                solo
                :hide-details="false"
                :rules="[optionalNumberRule('胸高周長 (公分)')]"
                @click="changeTreeImage('perimeter')"
                @input="
                  calculateDiameter('recheck', treeData.recheck.perimeter)
                "
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="6" lg="4">
          <img
            :src="currentTreeImage.src"
            :alt="currentTreeImage.description"
            :title="currentTreeImage.description"
            style="object-fit: contain;width: 100%;height: 100%;"
          />
        </v-col>
      </v-row>

      <v-row style="font-size:1.25rem; font-weight:600; color:#D3273B">
        <v-col style="text-align:center">
          <span>
            本功能係教學演示及估算用途，數據僅作為校園估算碳匯之參考，不具其他用途使用之效力
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="text-center mt-14 mb-16">
          <v-btn
            :color="'#FFF777'"
            title="開始計算"
            class="ct-text-bolder"
            @click="calculateTreeCarbon"
          >
            <span style="display:inline-block">開始計算</span>
            <img
              :src="iconArrowSrc"
              alt="開始計算"
              title="開始計算"
              class="ml-1"
            />
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="formulaDialog" max-width="545">
        <div style="min-height:485px;position:relative;" class="light white">
          <div style="padding:20px;height: 485px">
            <img
              :src="formulaIllustrateSrc"
              alt="公式說明"
              title="公式說明"
              style="object-fit: contain;height: 100%;"
            />
          </div>
          <div style="height: 80px;"></div>
          <div style="position:absolute;bottom:0;left:0;right:0">
            <hr />
            <div class="d-flex justify-center align-center my-6">
              <v-btn
                :color="'#FFF777'"
                class="ct-text-bolder"
                @click="formulaDialog = false"
                >關閉視窗</v-btn
              >
            </div>
          </div>
        </div>
      </v-dialog>
    </v-form>
    <measurement-guide-dialog v-model="measurementDialog" />
    <branch-conversion-dialog
      v-model="branchDialog"
      :target-label="branchTarget === 'base' ? '基準值' : '複測值'"
      @converted="applyBranchConversion"
    />
  </v-container>
</template>

<script>
import MeasurementGuideDialog from "./measurementGuideDialog.vue";
import BranchConversionDialog from "./branchConversionDialog.vue";

export default {
  components: { MeasurementGuideDialog, BranchConversionDialog },
  props: {
    treeCo2List: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      entryCo2List: [
        {
          Sno: 1,
          Name: "闊葉樹",
        },
        {
          Sno: 2,
          Name: "針葉樹",
        },
        {
          Sno: 3,
          Name: "棕櫚科",
        },
      ],
      formulaDialog: false,
      measurementDialog: false,
      branchDialog: false,
      branchTarget: "base",
      isAdvance: false,
      treeData: {
        isAdvance: false,
        base: {
          height: "",
          diameter: "",
          perimeter: "",
        },
        recheck: {
          height: "",
          diameter: "",
          perimeter: "",
        },
        type: "",
      },
      selectedIndex: 0,
      treeImages: [
        {
          name: "tree_default",
          description: "樹木儲存了多少二氧化碳?",
          src: require("@/assets/images/carbon/tree_default.png"),
        },
        {
          name: "tree_height",
          description:
            "樹高為樹木根部到樹冠頂部間的直線距離長度，一般可透過測高桿或仰角推算方式進行測量。",
          src: require("@/assets/images/carbon/tree_height.png"),
        },
        {
          name: "tree_diameter",
          description:
            "樹木的直徑一般以離地面1.3公尺的位置作為代表，故又稱為胸高直徑，可由直徑尺直接測量或是測量周長後進行換算。",
          src: require("@/assets/images/carbon/tree_diameter.png"),
        },
        {
          name: "tree_perimeter",
          description:
            "樹木的直徑一般以離地面1.3公尺的位置作為代表，故又稱為胸高直徑，可由直徑尺直接測量或是測量周長後進行換算。",
          src: require("@/assets/images/carbon/tree_perimeter.png"),
        },
        {
          name: "tree_type",
          description:
            "可由樹牌查看樹木品種；亦可觀察樹葉形態辨別樹木屬於針葉或闊葉植物，葉形針狀多為針葉植物；葉形扁平則多為闊葉植物。",
          src: require("@/assets/images/carbon/tree_type.png"),
        },
      ],
      iconArrowSrc: require("@/assets/images/carbon/icon_arror.svg"),
      formulaIllustrateSrc: require("@/assets/images/carbon/formula-illustrate.png"),
    };
  },
  computed: {
    currentTreeImage() {
      // 確保 selectedIndex 在有效範圍內
      const index = Math.max(
        0,
        Math.min(this.selectedIndex, this.treeImages.length - 1),
      );
      return this.treeImages[index];
    },
  },
  methods: {
    openBranchDialog(target) {
      this.branchTarget = target;
      this.branchDialog = true;
    },
    applyBranchConversion({ diameter, perimeter }) {
      const target = this.treeData[this.branchTarget];
      target.diameter = diameter;
      target.perimeter = perimeter;
      this.changeTreeImage("diameter");
    },
    isFilled(value) {
      return (
        value !== null && value !== undefined && String(value).trim() !== ""
      );
    },
    isNumeric(value) {
      return /^\d+(\.\d+)?$/.test(String(value));
    },
    requiredNumberRule(label) {
      return (value) =>
        (this.isFilled(value) && this.isNumeric(value)) || `請輸入正確${label}`;
    },
    optionalNumberRule(label) {
      return (value) =>
        !this.isFilled(value) || this.isNumeric(value) || `請輸入正確${label}`;
    },
    changeTreeImage(name) {
      switch (name) {
        case "height":
          this.selectedIndex = 1;
          break;
        case "diameter":
          this.selectedIndex = 2;
          break;
        case "perimeter":
          this.selectedIndex = 3;
          break;
        case "type":
          this.selectedIndex = 4;
          break;
        default:
          this.selectedIndex = 0;
      }
    },
    calculatePerimeter(target, diameter) {
      if (!this.isFilled(diameter)) {
        this.treeData[target].perimeter = "";
        return;
      }

      if (!this.isNumeric(diameter)) {
        return;
      }

      const perimeter = Math.PI * +diameter;
      this.treeData[target].perimeter = perimeter.toFixed(1);
    },
    calculateDiameter(target, perimeter) {
      if (!this.isFilled(perimeter)) {
        this.treeData[target].diameter = "";
        return;
      }

      if (!this.isNumeric(perimeter)) {
        return;
      }

      const diameter = +perimeter / Math.PI;
      this.treeData[target].diameter = diameter.toFixed(1);
    },
    hasAnyRecheck() {
      const { height, diameter, perimeter } = this.treeData.recheck;
      return [height, diameter, perimeter].some((value) =>
        this.isFilled(value),
      );
    },
    hasAllRecheck() {
      const { height, diameter, perimeter } = this.treeData.recheck;
      return [height, diameter, perimeter].every((value) =>
        this.isFilled(value),
      );
    },
    calculateTreeCarbon() {
      const type = this.$refs.treeType;
      const baseHeight = this.$refs.baseHeight;
      const baseDiameter = this.$refs.baseDiameter;
      const basePerimeter = this.$refs.basePerimeter;
      const recheckHeight = this.$refs.recheckHeight;
      const recheckDiameter = this.$refs.recheckDiameter;
      const recheckPerimeter = this.$refs.recheckPerimeter;

      this.$refs.form.validate();
      for (const item of [type, baseHeight, baseDiameter, basePerimeter]) {
        if (!item.valid) {
          item.focus();
          return;
        }
      }

      const hasAnyRecheck = this.hasAnyRecheck();
      const hasAllRecheck = this.hasAllRecheck();

      if (hasAnyRecheck && !hasAllRecheck) {
        const emptyField = [
          { value: this.treeData.recheck.height, ref: recheckHeight },
          { value: this.treeData.recheck.diameter, ref: recheckDiameter },
          { value: this.treeData.recheck.perimeter, ref: recheckPerimeter },
        ].find((item) => !this.isFilled(item.value));

        if (emptyField && emptyField.ref) {
          emptyField.ref.focus();
        }

        alert("若填寫複測值，請完整輸入樹高、胸高直徑與胸高周長。");
        return;
      }

      if (hasAllRecheck) {
        for (const item of [recheckHeight, recheckDiameter, recheckPerimeter]) {
          if (item && typeof item.validate === "function") {
            item.validate();
          }
          if (!item.valid) {
            item.focus();
            return;
          }
        }
      }

      this.$emit("calculateTree", JSON.parse(JSON.stringify(this.treeData)));
    },
  },
};
</script>
<style lang="scss" scoped>
.calculator-title {
  @include px-size(font-size, 16, 1);
  @include px-size(line-height, 16, 1);
  font-size: 1.75rem;
  white-space: nowrap;
  color: #776556;
}

.field-row {
  flex-wrap: nowrap;
}

.field-label-col {
  flex: 0 0 auto;
  width: 14rem;
  max-width: 14rem;
}

.field-input-col {
  flex: 1 1 0;
  min-width: 0;
}

.measurement-actions .field-label-col {
  text-align: center;
}
.action-group {
  flex-wrap: wrap;
  row-gap: 12px;
}
.measurement-actions .v-btn {
  max-width: 100%;
  padding: 0 8px !important;
}

.formula-wrap {
  text-align: center;
}

.required-note {
  display: inline-block;
  margin-left: 0.25rem;
  white-space: nowrap;
  font-size: 0.875rem;
  line-height: 1.2;
  color: #d3273b;
}

@media all and (max-width: 600px) {
  .calculator-title {
    font-size: 1.3rem;
    line-height: 1.3;
  }
}

@media all and (max-width: 960px) {
  .compare-form {
    overflow-x: visible;
    padding-bottom: 0.25rem;
  }

  .field-row {
    flex-wrap: wrap;
    min-width: 0;
  }

  .field-label-col {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.25rem;
  }

  .compare-title-spacer {
    display: none;
  }

  .formula-wrap {
    width: 100%;
    margin-left: 0 !important;
    justify-content: center;
    text-align: center;
  }

  .required-note {
    font-size: 0.8125rem;
  }

  .action-group {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center !important;
  }
}

.shadow-btn {
  box-shadow: none;
}

.compare-title {
  font-size: clamp(1.2rem, 2.1vw, 2rem);
  line-height: 1.1;
  color: #0f7c1f;
  font-weight: 700;
}
</style>
